import { useState } from 'react';
import { OptionValue, OptionRaw } from '@trukt/portal-utils/Option';
import { SelectOptionProps } from './SelectOption.types';

export const useValue = <Value extends OptionValue = string, Raw extends OptionRaw = unknown>(
  options: SelectOptionProps<Value, Raw>['options'],
  selectedValueId: SelectOptionProps<Value, Raw>['selectedValueId'],
) => {
  const currentOption = options?.find((option) => option.value === selectedValueId);

  // We include a "previousOption" parameter because the available choices can dynamically change
  // in response to user input. Input changes trigger queries fetching new options. However,
  // the presence of new options doesn't necessarily indicate that the user has made a new selection yet.
  // The "previousOption" parameter helps us retain the user's last selection even when options are updated.

  const [previousSelection, setPreviousSelection] = useState(() => ({
    selectedValueId,
    option: currentOption,
  }));

  if (previousSelection.selectedValueId !== selectedValueId) {
    setPreviousSelection({ selectedValueId, option: currentOption });
    return currentOption ?? null;
  }

  // This is a fix for the issue where the value is set when undefined is returned as value. DO NOT REMOVE.
  return currentOption ?? previousSelection.option ?? null;
};
